import { Box, Drawer, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { useDispatch, useSelector } from 'react-redux';
import { Dispatch, RootState } from 'shared/store/store';
import Imagen from '../../assets/index'
import { ButtonLogout } from '../ButtonLogout';
import { useWidth } from 'shared/hooks/HookDetailedConsultation/useWidth';
import { MenuList } from './MenuList';
import { useInfoUser } from 'shared/hooks/useInfoUser';
import SearchIcon from '@mui/icons-material/Search';
import './styles/_sidebar.scss'
import { useNavigateToCustom } from 'shared/hooks/useNavigateToCustom';
import { Spinner } from '../Spinner';
import { Fragment } from 'react';

export const SideBar = () => {

	const dispatch = useDispatch<Dispatch>();
	const { menuDrawer } = useSelector((state: RootState) => state);
	const { open, collapsed } = menuDrawer
	const { loading } = useSelector((rootState: RootState) => rootState.loading.models.electronicDocuments);
	const { width } = useWidth();
	const {user} = useInfoUser();
	const {navigateHome, navigateToInvoices} = useNavigateToCustom();

	const closeOutsideElementUI = (event: any) => { 
		event.target === event.currentTarget && animateAndCloseMenu() 
	}

	const closeMenu = () => { 
		dispatch.menuDrawer.closeMenu() 
	};

	const animateAndCloseMenu = () => {
		const menu = document.querySelector('.menuMobile');
		if (menu) {
			menu.classList.add('hidden');
			// Esperar a que la animación termine antes de cerrar el menú
			menu.addEventListener('animationend', closeMenu, { once: true });
		}
	}

	const handleToggleCollapsed = () => {
		dispatch.menuDrawer.toggleCollapsed();
	};

	return (
		<Fragment>
			{
				width > 900 ?
					<Box component="nav" aria-label="menu trazabilidad" data-testid="menu_drawer">
						<Drawer
							className={`menuDrawer${collapsed ? ' collapsed' : ''}`}
							variant="persistent"
							anchor="left"
							open={true}
							onClose={dispatch.menuDrawer.closeMenu}
							ModalProps={{
								keepMounted: true,
							}}
						>
							<Box className='headerContenedor' style={{position: 'relative'}}>
								<IconButton
									className='collapseButton'
									onClick={handleToggleCollapsed}
									style={{position: 'absolute', right: 8, top: 8, zIndex: 10}}
									size="small"
									sx={{ color: '#fff' }}
									data-testid="collapse_button"
								>
									{collapsed ? <ChevronRightIcon /> : <ChevronLeftIcon />}
								</IconButton>
								<Box className='containerImgName'></Box>
							</Box>
							<MenuList/>
							<Box className='contentBtnLogout'>
								<ButtonLogout collapsed={collapsed}/>
							</Box>
						</Drawer>
					</Box>
				: open &&
					<Box data-testid='menu_mobile' className={`menuMobile${collapsed ? ' collapsed' : ''}`} onClick={closeOutsideElementUI}>
						<Box className='menuMask'>
							<IconButton className='buttonMenu' onClick={animateAndCloseMenu}>
								<CloseIcon />
							</IconButton>
							<Box 
								className='headerContenedor'
								onClick={navigateHome}
								data-testid='headerContenedor'
							>
								<img src={Imagen.logoGobernacionAntioquia} alt="trazabilidad" />
							</Box>
							<Box className={'itemSearchMobile'} onClick={navigateToInvoices}>
								<SearchIcon/>
							</Box>
						</Box>
						<Box className='toogleContainer'>
							<Box className='containerImgName'>
							</Box>
						</Box>
						<Box className='containerContentMenu'>
							<Box className='mask'></Box>
							<Box className='containerItemsMenu'>
								<MenuList/>
							</Box>
							<Box className='contentBtnLogout'>
								<ButtonLogout closeMenu={animateAndCloseMenu} collapsed={collapsed}/>
							</Box>
						</Box>
					</Box>
			}
			{ (loading) &&  <Spinner/>}
		</Fragment>
	);
};
